<template>
    <div>
        <modal :show.sync="addProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar producto</h6>
                <div class="form-group">
                    <label>Detalle *</label>
                    <fg-input   type="text"
                                name="detalle"
                                placeholder="detalle"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('detalle')"
                                v-model="productName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Cantidad *</label>
                    <fg-input   type="number"
                                name="cantidad"
                                placeholder="cantidad"
                                autocomplete="off"
                                v-validate="modelValidations.item_quantity"
                                :error="getError('cantidad')"
                                v-model="productQuantity">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Precio compra und.</label>
                    <vue-numeric  :max=999999999 currency="$" autocomplete="off" name="costo unidad" v-validate="modelValidations.sales" :error="getError('precio de compra')" separator="." class="form-control" v-model="productCostUnity"></vue-numeric>
                </div>
                <div v-if="validateProductionStudy()" class="form-group">
                    <label>Precio venta und.</label>
                    <vue-numeric  :max=999999999 currency="$" autocomplete="off" name="costo unidad" v-validate="modelValidations.sales" :error="getError('precio de compra')" separator="." class="form-control" v-model="productSaleUnity"></vue-numeric>
                </div>
                <div v-if="inventory_prices_validate_computed == false" class="alert alert-danger">
                    <span>El precio de compra de un ítem no puede ser mayor al precio de venta</span>
                </div>
                <div v-if="productCostTotalComputed != 0" class="alert alert-warning mt-2">
                    <span>Valor total: {{setFormat(productCostTotalComputed)}}</span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button v-if="inventory_prices_validate_computed == true" type="default" link @click="addProductToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar producto</h6>
                <div class="form-group">
                    <label>Detalle *</label>
                    <fg-input   type="text"
                                name="detalle"
                                placeholder="detalle"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('detalle')"
                                v-model="productName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Cantidad *</label>
                    <fg-input   type="number"
                                name="cantidad"
                                placeholder="cantidad"
                                autocomplete="off"
                                v-validate="modelValidations.sales"
                                :error="getError('cantidad')"
                                v-model="productQuantity">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Precio compra und.</label>
                    <vue-numeric  :max=999999999 currency="$" autocomplete="off" name="costo unidad" v-validate="modelValidations.sales" :error="getError('precio de compra')" separator="." class="form-control" v-model="productCostUnity"></vue-numeric>
                </div>
                <div v-if="validateProductionStudy()" class="form-group">
                    <label>Precio venta und.</label>
                    <vue-numeric  :max=999999999 currency="$" autocomplete="off" name="costo unidad" v-validate="modelValidations.sales" :error="getError('precio de compra')" separator="." class="form-control" v-model="productSaleUnity"></vue-numeric>
                </div>
                <div v-if="inventory_prices_validate_computed == false" class="alert alert-danger">
                    <span>El precio de compra de un ítem no puede ser mayor al precio de venta</span>
                </div>
                <div v-if="productCostTotalComputed != 0" class="alert alert-warning mt-2">
                    <span>Valor total: {{setFormat(productCostTotalComputed)}}</span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button v-if="inventory_prices_validate_computed == true" type="default" link @click="editProductToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="addExpense" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar gasto</h6>
                <div class="form-group">
                    <label>Gasto *</label>
                    <fg-input   type="text"
                                name="nombre del gasto"
                                placeholder="nombre del gasto"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('nombre del gasto')"
                                v-model="expenseName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999 currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="expenseValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelAddExpense()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="addExpenseToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editExpense" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar gasto</h6>
                <div class="form-group">
                    <label>Gasto *</label>
                    <fg-input   type="text"
                                name="gasto"
                                :disabled="expenseLocked"
                                placeholder="gasto"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('gasto')"
                                v-model="expenseName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999 :disabled="taxLocked" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="expenseValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelEditExpense()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="editExpenseToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Hoja de trabajo</h4>
        </div>
        <!-- Selection -->
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Seleccione </h6>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <p-switch type="warning" v-model="operatingSwitches.expenses">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch>
                        <label class="ml-2">Gastos operativos</label>
                    </div>
                    <div v-if="subcategory != 'transporte'" class="col-md-12">
                        <p-switch type="warning" v-model="operatingSwitches.inventory">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch>
                        <label class="ml-2">Inventario</label>
                    </div>
                    <div v-if="subcategory != 'transporte'" class="col-md-12">
                        <p-switch type="warning" v-model="operatingSwitches.creditSales">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch>
                        <label class="ml-2">Recuperación ventas crédito</label>
                    </div>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <!-- /Selection -->
        <!-- Expenses -->
        <card v-if="operatingSwitches.expenses" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Gastos operativos</h6>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.periodicity"
                                :error="getError('periodicidad')"
                                v-model="periodicity">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="periodicity">
                            <el-option
                                    class="select-warning"
                                    value="Diaria"
                                    label="Diaria">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Semanal"
                                    label="Semanal">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="periodicity == 'Diaria'" class="form-group">
                        <label>Número de días que trabaja en la semana</label>
                        <fg-input   type="number"
                                    tabindex="1"
                                    name="días"
                                    placeholder="días"
                                    autocomplete="off"
                                    v-validate="modelValidations.periodicity"
                                    data-vv-id = "días"
                                    :error="getError('días')"
                                    v-model="periodicity_days">
                        </fg-input>
                    </div>
                <div v-if="!periodicityFlag && periodicity == ''" class="alert alert-danger mt-2">
                    <span>Seleccione la periodicidad de los gastos operativos</span>
                </div>
                <div v-if="periodicity == 'Diaria' && !periodicityDaysFlag" class="alert alert-danger mt-2">
                    <span>Especifique los días que trabaja en la semana</span>
                </div>
                <el-table v-if="actualExpenses.length" :data="actualExpenses"  ref="expensesTable"  @row-dblclick="showEditExpenseMethod" highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column label="Gasto" property="name"></el-table-column>
                    <el-table-column label="Valor">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.value)}}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="Total">
                        <template slot-scope="scope">
                            <span v-if="monthlyNumber != ''">{{ setFormat(scope.row.value * monthlyNumber)}}</span>
                            <span v-else>{{ setFormat(0)}}</span>
                        </template>
                    </el-table-column> -->
                </el-table>

                <div>
                    <p-button
                        @click="addExpenseMethod()"
                        type="default"
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar gasto
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="editExpenseMethod()"
                        type="default"
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar gasto
                    </p-button>
                    <br>
                    <p-button v-if="currentRow && currentRow.locked == false"
                        @click="removeExpenseMethod()"
                        type="default"
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar gasto
                    </p-button>
                </div>
                <div v-if="allExpensesMonthlyCostComputed != 0" class="alert alert-warning mt-2">
                    <span>Costo gastos operativos mes: {{setFormat(allExpensesMonthlyCostComputed)}}</span>
                </div>
                <div v-if="allOthersExpensesMonthlyCostComputed != 0" class="alert alert-warning mt-2">
                    <span>Costo otros gastos mes: {{setFormat(allOthersExpensesMonthlyCostComputed)}}</span>
                </div>
                <div v-if="allCostsComputed != 0" class="alert alert-success mt-2">
                    <span>Total gastos: {{setFormat(allCostsComputed)}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <!-- /Expenses -->
        <!-- Inventory -->
        <card v-if="operatingSwitches.inventory" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Inventario</h6>
            </div>
            <div class="card-body">
                <el-table v-if="products.length" :data="products"  ref="productsTable"  @row-dblclick="showEditInventoryMethod" highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <p>Producto: {{ props.row.productName }}</p>
                            <p>Cantidad: {{ props.row.productQuantity }}</p>
                            <p>Precio compra: {{ setFormat(props.row.productCostUnity) }}</p>
                            <p v-if="validateProductionStudy()">Precio venta: {{ setFormat(props.row.productSaleUnity) }}</p>
                            <p>Valor total: {{ setFormat(props.row.productCostTotal) }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="Detalle" property="productName"></el-table-column>
                    <el-table-column label="Total">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.productCostTotal)}}</span>
                        </template>
                    </el-table-column>
                </el-table>

                <div>
                    <p-button
                        @click="addProductMethod()"
                        type="default"
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar ítem
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="editProductMethod()"
                        type="default"
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar ítem
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="removeProductMethod()"
                        type="default"
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar ítem
                    </p-button>
                </div>
                <div v-if="totalInventory != 0" class="alert alert-warning mt-2">
                    <span>Total inventario: {{setFormat(totalInventory)}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <!-- /Inventory -->
        <!-- Credit Sales -->
        <card v-if="operatingSwitches.creditSales" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Recuperación ventas crédito</h6>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Monto *</label>
                    <vue-numeric  :max=999999999 currency="$" autocomplete="off" name="monto" separator="." class="form-control" v-model="creditSales.value"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Descripción</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="descripción de la recuperación"
                                autocomplete="off"
                                v-validate="modelValidations.description_sales"
                                :error="getError('descripción de la recuperación')"
                                v-model="creditSales.description">
                    </fg-input>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <!-- /Credit Sales -->
        <!-- <div v-if="allCostsComputed != 0" class="alert alert-success">
            <span>Gastos totales mes: {{ setFormat(allCostsComputed)}}</span>
        </div> -->
        <div class="text-right">
            <p-button v-if="verifyNext" @click="saveCosts()" type="warning">Siguiente</p-button>
            <p-button @click="toSalesCostsSelection()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option, Table, TableColumn} from 'element-ui'
    import Expenses from 'src/util/Others/OperatingExpenses'
    import Taxes from 'src/util/Services/Taxes'
    import moment from 'moment'
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal
        },
        data() {
        return {
            form: {
                average_selection: '',
            },
            operatingSwitches: {
                expenses: false,
                inventory: false,
                creditSales: false,
            },
            creditSales: {
                value: 0,
                description: ''
            },
            subcategory: null,
            periodicity: '',
            periodicityFlag: true,
            periodicityDaysFlag: true,
            periodicity_days: 0,
            expenses : [],
            actualExpenses: [],
            currentRow: null,
            addExpense: false,
            editExpense: false,
            addExpenseIndex: null,
            addProduct: false,
            editProduct: false,
            addProductIndex: null,
            monthlyNumber: '',
            expenseName: '',
            expenseValue: '',
            expenseLocked: false,
            taxLocked: false,
            productName: '',
            productQuantity: '',
            productCostUnity: '',
            productSaleUnity: '',
            productCostTotal: '',
            productMonthlyCost: '',
            modelValidations: {
                average_selection: {
                    required: false
                },
                item_name: {
                    required: false,
                    max: 64
                },
                description_sales: {
                    max: 32
                },
                item_quantity: {
                    required: false
                },
                periodicity: {
                    required: false
                },
                sales: {
                    required: false
                },
                product_name: {
                    required: false
                },
                item_costs: {
                    required: false,
                    min: 1,
                    max: 28
                }
            },
            products: [

            ],
            costs: [],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
        }
        },
        watch: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'operatingSwitches.expenses': function (newVal, oldVal) {
                if (!newVal) {
                    this.periodicityDaysFlag = true;
                    this.periodicityFlag = true;
                    this.periodicity= '';
                    this.periodicity_days= 0;
                    this.actualExpenses = [];
                    for (let i=0; i<this.expenses.length;i++) {
                        this.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'operatingSwitches.inventory': function (newVal, oldVal) {
                if (!newVal) {
                    this.products = []
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'operatingSwitches.creditSales': function (newVal, oldVal) {
                if (!newVal) {
                    this.creditSales.value = 0;
                    this.creditSales.description = '';
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            periodicity_days: function(newVal, oldVal) {
                if(newVal < 0) {
                    this.periodicity_days = 1;
                }
                else if(newVal > 7) {
                    this.periodicity_days = 7;
                }
                else {
                    this.periodicity_days = parseFloat(newVal)
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            periodicity: function(newVal, oldVal) {

                if (oldVal != '') {
                    this.periodicity_days = 0;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCostUnity: function(newVal) {
                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                if (subcategory == 'produccion') {
                    this.productSaleUnity = newVal;
                }
            }
        },
        computed: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            inventory_prices_validate_computed () {
                if (this.productCostUnity <= this.productSaleUnity) {
                    return true
                }
                else {
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            verifyNext () {
                if (!this.operatingSwitches.expenses && !this.operatingSwitches.inventory) {
                    return true
                }
                else if(this.operatingSwitches.expenses && this.operatingSwitches.inventory &&  this.allCostsComputed != 0 && this.totalInventory != 0) {
                    return true
                }
                else if(this.operatingSwitches.expenses  &&  this.allCostsComputed ) {
                    if(!this.operatingSwitches.inventory) {
                        return true
                    }
                }
                else if(this.operatingSwitches.inventory  &&  this.totalInventory ) {
                    if(!this.operatingSwitches.expenses) {
                        return true
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCostTotalComputed() {
                var total = this.productQuantity * this.productCostUnity;
                this.productCostTotal = total;
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            totalInventory() {
                var sum = 0;
                for (let i = 0;i<this.products.length;i++) {
                    sum = sum + this.products[i].productCostTotal;
                }
                return sum
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthlyCostComputed() {
                var total = 0;
                if (this.monthlyNumber != '') {
                    var total = this.productQuantity * this.productCostUnity * this.monthlyNumber;
                    this.productMonthlyCost = total;
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allExpensesMonthlyCostComputed() {
                var sum = 0;
                var flag = 0;
                if (this.periodicity == 'Diaria') {
                    this.periodicityDaysFlag = true;
                    if(this.periodicity_days != 0) {
                        flag = parseInt(this.periodicity_days)* 4;
                    }
                    else {
                        this.periodicityDaysFlag = false;
                    }
                }
                else if (this.periodicity == 'Semanal') {
                    flag = 4;
                }
                else if (this.periodicity == 'Mensual') {
                    flag = 1;
                }
                this.periodicityFlag = true;
                for (let i=0;i<this.actualExpenses.length;i++) {
                    if (this.actualExpenses[i].locked) {
                        if (flag == 0 && this.actualExpenses[i].value != 0) {
                                this.periodicityFlag = false;
                        }
                        sum = sum + ((this.actualExpenses[i].value)* flag);
                    }
                }
                return sum
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allOthersExpensesMonthlyCostComputed() {
                var sum = 0;
                var flag = 0;
                if (this.periodicity == 'Diaria') {
                    this.periodicityDaysFlag = true;
                    if(this.periodicity_days != 0) {
                        flag = parseInt(this.periodicity_days)* 4;
                    }
                    else {
                        this.periodicityDaysFlag = false;
                    }
                }
                else if (this.periodicity == 'Semanal') {
                    flag = 4;
                }
                else if (this.periodicity == 'Mensual') {
                    flag = 1;
                }
                this.periodicityFlag = true;
                for (let i=0;i<this.actualExpenses.length;i++) {
                    if (!this.actualExpenses[i].locked) {
                        if (flag == 0 && this.actualExpenses[i].value != 0) {
                                this.periodicityFlag = false;
                        }
                        sum = sum + ((this.actualExpenses[i].value)* flag);
                    }
                }
                return sum
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allCostsComputed() {
                return this.allExpensesMonthlyCostComputed + this.allOthersExpensesMonthlyCostComputed;
            }
        },
        methods: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            validateProductionStudy () {
                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                if (subcategory == 'produccion') {
                    return false
                }
                else {
                    return true
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showEditExpenseMethod (row) {
                this.expenseName= row.name;
                this.expenseValue= row.value;
                this.expenseLocked = row.locked;
                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                if (row.name == 'Impuestos' && subcategory == 'transporte') {
                    this.taxLocked = true;
                }
                this.editExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showEditInventoryMethod (row) {
                this.productName= row.productName;
                this.productQuantity= row.productQuantity;
                this.productCostUnity= row.productCostUnity;
                this.productSaleUnity= row.productSaleUnity;
                this.productCostTotal= row.productCostTotal;
                this.productMonthlyCost= row.productMonthlyCost;
                this.editProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            // addProductToList () {
            //     this.$validator.validateAll().then(isValid => {
            //         if(isValid){
            //             if (this.itemName == '' || this.itemPercent == 0) {
            //                 this.showNotificationError('El campo nombre de ítem y porcentaje no pueden estar vacíos');
            //             }
            //             else {
            //                 this.products[this.addProductIndex].items.push({
            //                     itemName: this.itemName,
            //                     itemPurchasePrice: this.itemPurchasePrice,
            //                     itemSalePrice: this.itemSalePrice,
            //                     itemPercent: this.itemPercent
            //                 })
            //                 this.resetItem();
            //                 this.addProduct = false;
            //                 this.addProductIndex = null;
            //                 this.showNotificationSuccess('Ítem agregado correctamente');
            //             }
            //         }
            //     })
            // },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.expenseName == '') {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            let indexActual = 0;
                            indexActual = this.actualExpenses.findIndex((tableRow) => tableRow.name === this.expenseName);
                            var index = this.actualExpenses.indexOf(this.currentRow);
                            if (indexActual < 0 || indexActual == index || this.actualExpenses[indexActual].locked == true) {
                                var index = this.actualExpenses.indexOf(this.currentRow);
                                this.actualExpenses[index].name = this.expenseName;
                                this.actualExpenses[index].value = this.expenseValue;
                                this.resetExpense();
                                this.currentRow = null;
                                this.$refs.expensesTable.setCurrentRow();
                                this.editExpense = false;
                                this.showNotificationSuccess('Gasto editado correctamente');
                            }
                            else {
                                this.showNotificationError('Ya existe un gasto con el mismo nombre');
                            }

                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseMethod (row) {
                // this.addProductIndex = row;
                this.resetExpense();
                this.addExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.productName == '' || this.productCostTotal == 0) {
                            this.showNotificationError('El campo nombre de producto y total no pueden estar vacíos');
                        }
                        else {
                            this.products.push({
                                productName: this.productName,
                                productQuantity: this.productQuantity,
                                productCostUnity: this.productCostUnity,
                                productSaleUnity: this.productSaleUnity,
                                productCostTotal: this.productCostTotal,
                                productMonthlyCost: this.productMonthlyCost,
                            })
                            this.resetProduct();
                            this.addProduct = false;
                            this.showNotificationSuccess('Producto agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetProduct () {
                this.productName = '',
                this.productQuantity = '',
                this.productCostUnity = '',
                this.productSaleUnity = '',
                this.productCostTotal = '',
                this.productMonthlyCost = ''

            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductMethod () {
                this.productName= this.currentRow.productName;
                this.productQuantity= this.currentRow.productQuantity;
                this.productCostUnity= this.currentRow.productCostUnity;
                this.productSaleUnity= this.currentRow.productSaleUnity;
                this.productCostTotal= this.currentRow.productCostTotal;
                this.productMonthlyCost= this.currentRow.productMonthlyCost;
                this.editProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeProductMethod () {
                this.products.splice(this.products.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.productName == '' || this.productCostTotal == 0) {
                            this.showNotificationError('El campo nombre de producto y total no pueden estar vacíos');
                        }
                        else {
                            var index = this.products.indexOf(this.currentRow);
                            this.products[index].productName = this.productName;
                            this.products[index].productQuantity = this.productQuantity;
                            this.products[index].productCostUnity = this.productCostUnity;
                            this.products[index].productSaleUnity = this.productSaleUnity;
                            this.products[index].productCostTotal = this.productCostTotal;
                            this.products[index].productMonthlyCost = this.productMonthlyCost;
                            this.resetProduct();
                            this.currentRow = null;
                            this.$refs.productsTable.setCurrentRow();
                            this.editProduct = false;
                            this.showNotificationSuccess('Producto editado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod (row) {
                this.addProductIndex = row;
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddProduct () {
                this.addProduct = false;
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditProduct () {
                this.editProduct = false;
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName = '';
                this.itemPurchasePrice = '';
                this.itemSalePrice = '';
                this.itemPercent = '';
                this.productName= '';
                this.productQuantity= '';
                this.productCostUnity= '';
                this.productSaleUnity= '';
                this.productCostTotal= '';
                this.productMonthlyCost= '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.expenseName == '') {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            let indexActual = 0;
                            indexActual = this.actualExpenses.findIndex((tableRow) => tableRow.name === this.expenseName);
                            console.log(indexActual);
                            if (indexActual < 0) {
                                var id = this.actualExpenses.length + 1;
                                this.actualExpenses.push({
                                    id: id,
                                    name: this.expenseName,
                                    value: this.expenseValue,
                                    locked: false
                                })
                                this.resetExpense();
                                this.addExpense = false;
                                this.showNotificationSuccess('Gasto agregado correctamente');
                            }
                            else {
                                this.showNotificationError('Ya existe un gasto con el mismo nombre');
                            }

                        }
                    }
                })

            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetExpense () {
                this.expenseName = '';
                this.expenseValue = '';
                this.expenseLocked = false;
                this.taxLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod () {
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseMethod () {
                this.expenseName= this.currentRow.name;
                this.expenseValue= this.currentRow.value;
                this.expenseLocked = this.currentRow.locked;
                this.editExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeExpenseMethod () {
                this.actualExpenses.splice(this.actualExpenses.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddExpense () {
                this.addExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditExpense () {
                this.editExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                if (subcategory == 'catalogo') {
                    this.$router.push('/asessments/new_asessment/customer/costs/business/catalog');
                }
                else {
                    this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveCosts () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.$store.state.isCustomer) {
                            var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                            // Validación del valor de los productos en las ventas y los productos
                            var salesChange = false;
                            if (subcategory == 'produccion' && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].sales.length > 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsProductionItem.length > 0) {
                                var salesProducts = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].sales[0].products;
                                var salesProductsCount = 0;
                                var productionProducts = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsProductionItem;
                                var productionProductsCount = 0;
                                for (let i=0;i<salesProducts.length;i++) {
                                    salesProductsCount = salesProductsCount + parseFloat(salesProducts[i].productTotalSale);
                                }
                                for (let j=0;j<productionProducts.length;j++) {
                                    productionProductsCount = productionProductsCount + parseFloat(productionProducts[j].productTotalSale);
                                }
                                if (salesProductsCount != productionProductsCount) {
                                    salesChange = true;
                                }
                                // if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0 && (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != productionProductsCount)) {
                                //     salesChange = true;
                                // }
                            }
                            if (this.operatingSwitches.expenses) {
                                var finalExpenses = [];
                                finalExpenses.push({
                                    expenses: this.actualExpenses,
                                    total: this.allExpensesMonthlyCostComputed,
                                    others: this.allOthersExpensesMonthlyCostComputed,
                                    periodicity: this.periodicity,
                                    days: this.periodicity_days
                                })
                                this.$store.dispatch('setOperatingExpenses', finalExpenses).then(()=>{
                                    if (this.operatingSwitches.inventory) {
                                        var finalInventory = [];
                                        finalInventory.push({
                                            inventory: this.products,
                                            total: this.totalInventory
                                        })
                                        this.$store.dispatch('setInventory', finalInventory).then(()=>{
                                            this.$store.dispatch('setCreditSales', this.creditSales).then(()=>{
                                                var payload = {
                                                    stage: 'Ingreso de datos de negocio',
                                                    description: 'Se ingresan los costos, con gastos operativos e inventario',
                                                    dateTime: moment().format()
                                                };
                                                this.$store.dispatch('setChangeLog', payload).then(()=>{
                                                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].salesPopulate == false || salesChange == true) {
                                                        this.$router.push('/asessments/new_asessment/customer/sales');
                                                        if(salesChange) {
                                                            this.showNotificationError('Es necesario revisar las ventas, por esa razón ha sido redireccionado a esta sección');
                                                        }
                                                    }
                                                    else {
                                                        this.$router.push('/asessments/new_asessment/customer/others/business_references');
                                                    }
                                                });
                                            });
                                        });
                                    }
                                    else {
                                        this.$store.dispatch('setCreditSales', this.creditSales).then(()=>{
                                            var payload = {
                                                stage: 'Ingreso de datos de negocio',
                                                description: 'Se ingresan los costos, con gastos operativos y sin inventario',
                                                dateTime: moment().format()
                                            };
                                            this.$store.dispatch('setChangeLog', payload).then(()=>{
                                                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].salesPopulate == false || salesChange == true) {
                                                    this.$router.push('/asessments/new_asessment/customer/sales');
                                                    if(salesChange) {
                                                        this.showNotificationError('Es necesario revisar las ventas, por esa razón ha sido redireccionado a esta sección');
                                                    }
                                                }
                                                else {
                                                    this.$router.push('/asessments/new_asessment/customer/others/business_references');
                                                }
                                            });
                                        });
                                    }
                                });
                            }
                            else {
                                if (this.operatingSwitches.inventory) {
                                    var finalInventory = [];
                                    finalInventory.push({
                                        inventory: this.products,
                                        total: this.totalInventory
                                    })
                                    this.$store.dispatch('setInventory', finalInventory).then(()=>{
                                        this.$store.dispatch('setCreditSales', this.creditSales).then(()=>{
                                            var payload = {
                                                stage: 'Ingreso de datos de negocio',
                                                description: 'Se ingresan los costos, sin gastos operativos y con inventario',
                                                dateTime: moment().format()
                                            };
                                            this.$store.dispatch('setChangeLog', payload).then(()=>{
                                                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].salesPopulate == false || salesChange == true) {
                                                    this.$router.push('/asessments/new_asessment/customer/sales');
                                                    if(salesChange) {
                                                        this.showNotificationError('Es necesario revisar las ventas, por esa razón ha sido redireccionado a esta sección');
                                                    }
                                                }
                                                else {
                                                    this.$router.push('/asessments/new_asessment/customer/others/business_references');
                                                }
                                            });
                                        });
                                    });
                                }
                                else {
                                    this.$store.dispatch('setCreditSales', this.creditSales).then(()=>{
                                        var payload = {
                                            stage: 'Ingreso de datos de negocio',
                                            description: 'Se ingresan los costos, sin gastos operativos y sin inventario',
                                            dateTime: moment().format()
                                        };
                                        this.$store.dispatch('setChangeLog', payload).then(()=>{
                                            if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].salesPopulate == false || salesChange == true) {
                                                this.$router.push('/asessments/new_asessment/customer/sales');
                                                if(salesChange) {
                                                    this.showNotificationError('Es necesario revisar las ventas, por esa razón ha sido redireccionado a esta sección');
                                                }
                                            }
                                            else {
                                                this.$router.push('/asessments/new_asessment/customer/others/business_references');
                                            }
                                        });
                                    });
                                }
                            }
                        }
                        else if (this.$store.state.isSpouse) {
                            var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                            // Validación del valor de los productos en las ventas y los productos
                            var salesChange = false;
                            if (subcategory == 'produccion' && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].sales.length > 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsProductionItem.length > 0) {
                                var salesProducts = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].sales[0].products;
                                var salesProductsCount = 0;
                                var productionProducts = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsProductionItem;
                                var productionProductsCount = 0;
                                for (let i=0;i<salesProducts.length;i++) {
                                    salesProductsCount = salesProductsCount + parseFloat(salesProducts[i].productTotalSale);
                                }
                                for (let j=0;j<productionProducts.length;j++) {
                                    productionProductsCount = productionProductsCount + parseFloat(productionProducts[j].productTotalSale);
                                }
                                if (salesProductsCount != productionProductsCount) {
                                    salesChange = true;
                                }
                                // if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0 && (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != productionProductsCount)) {
                                //     salesChange = true;
                                // }
                            }
                            if (this.operatingSwitches.expenses) {
                                var finalExpenses = [];
                                finalExpenses.push({
                                    expenses: this.actualExpenses,
                                    total: this.allExpensesMonthlyCostComputed,
                                    others: this.allOthersExpensesMonthlyCostComputed,
                                    periodicity: this.periodicity,
                                    days: this.periodicity_days
                                })
                                this.$store.dispatch('setOperatingExpenses', finalExpenses).then(()=>{
                                    if (this.operatingSwitches.inventory) {
                                        var finalInventory = [];
                                        finalInventory.push({
                                            inventory: this.products,
                                            total: this.totalInventory
                                        })
                                        this.$store.dispatch('setInventory', finalInventory).then(()=>{
                                            this.$store.dispatch('setCreditSales', this.creditSales).then(()=>{
                                                var payload = {
                                                    stage: 'Ingreso de datos de negocio',
                                                    description: 'Se ingresan los costos, con gastos operativos e inventario',
                                                    dateTime: moment().format()
                                                };
                                                this.$store.dispatch('setChangeLog', payload).then(()=>{
                                                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].salesPopulate == false || salesChange == true) {
                                                        this.$router.push('/asessments/new_asessment/customer/sales');
                                                        if(salesChange) {
                                                            this.showNotificationError('Es necesario revisar las ventas, por esa razón ha sido redireccionado a esta sección');
                                                        }
                                                    }
                                                    else {
                                                        this.$router.push('/asessments/new_asessment/customer/others/business_references');
                                                    }
                                                });
                                            });
                                        });
                                    }
                                    else {
                                        this.$store.dispatch('setCreditSales', this.creditSales).then(()=>{
                                            var payload = {
                                                stage: 'Ingreso de datos de negocio',
                                                description: 'Se ingresan los costos, con gastos operativos y sin inventario',
                                                dateTime: moment().format()
                                            };
                                            this.$store.dispatch('setChangeLog', payload).then(()=>{
                                                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].salesPopulate == false || salesChange == true) {
                                                    this.$router.push('/asessments/new_asessment/customer/sales');
                                                    if(salesChange) {
                                                        this.showNotificationError('Es necesario revisar las ventas, por esa razón ha sido redireccionado a esta sección');
                                                    }
                                                }
                                                else {
                                                    this.$router.push('/asessments/new_asessment/customer/others/business_references');
                                                }
                                            });
                                        });
                                    }
                                });
                            }
                            else {
                                if (this.operatingSwitches.inventory) {
                                    var finalInventory = [];
                                    finalInventory.push({
                                        inventory: this.products,
                                        total: this.totalInventory
                                    })
                                    this.$store.dispatch('setInventory', finalInventory).then(()=>{
                                        this.$store.dispatch('setCreditSales', this.creditSales).then(()=>{
                                            var payload = {
                                                stage: 'Ingreso de datos de negocio',
                                                description: 'Se ingresan los costos, sin gastos operativos y con inventario',
                                                dateTime: moment().format()
                                            };
                                            this.$store.dispatch('setChangeLog', payload).then(()=>{
                                                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].salesPopulate == false || salesChange == true) {
                                                    this.$router.push('/asessments/new_asessment/customer/sales');
                                                    if(salesChange) {
                                                        this.showNotificationError('Es necesario revisar las ventas, por esa razón ha sido redireccionado a esta sección');
                                                    }
                                                }
                                                else {
                                                    this.$router.push('/asessments/new_asessment/customer/others/business_references');
                                                }
                                            });
                                        });
                                    });
                                }
                                else {
                                    this.$store.dispatch('setCreditSales', this.creditSales).then(()=>{
                                        var payload = {
                                            stage: 'Ingreso de datos de negocio',
                                            description: 'Se ingresan los costos, sin gastos operativos y sin inventario',
                                            dateTime: moment().format()
                                        };
                                        this.$store.dispatch('setChangeLog', payload).then(()=>{
                                            if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].salesPopulate == false || salesChange == true) {
                                                this.$router.push('/asessments/new_asessment/customer/sales');
                                                if(salesChange) {
                                                    this.showNotificationError('Es necesario revisar las ventas, por esa razón ha sido redireccionado a esta sección');
                                                }
                                            }
                                            else {
                                                this.$router.push('/asessments/new_asessment/customer/others/business_references');
                                            }
                                        });
                                    });
                                }
                            }
                        }
                        else if (this.$store.state.isGuarantor) {
                            var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                            // Validación del valor de los productos en las ventas y los productos
                            var salesChange = false;
                            if (subcategory == 'produccion' && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].sales.length > 0 && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsProductionItem.length > 0) {
                                var salesProducts = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].sales[0].products;
                                var salesProductsCount = 0;
                                var productionProducts = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsProductionItem;
                                var productionProductsCount = 0;
                                for (let i=0;i<salesProducts.length;i++) {
                                    salesProductsCount = salesProductsCount + parseFloat(salesProducts[i].productTotalSale);
                                }
                                for (let j=0;j<productionProducts.length;j++) {
                                    productionProductsCount = productionProductsCount + parseFloat(productionProducts[j].productTotalSale);
                                }
                                if (salesProductsCount != productionProductsCount) {
                                    salesChange = true;
                                }
                                // if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0 && (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != productionProductsCount)) {
                                //     salesChange = true;
                                // }
                            }
                            if (this.operatingSwitches.expenses) {
                                var finalExpenses = [];
                                finalExpenses.push({
                                    expenses: this.actualExpenses,
                                    total: this.allExpensesMonthlyCostComputed,
                                    others: this.allOthersExpensesMonthlyCostComputed,
                                    periodicity: this.periodicity,
                                    days: this.periodicity_days
                                })
                                this.$store.dispatch('setOperatingExpenses', finalExpenses).then(()=>{
                                    if (this.operatingSwitches.inventory) {
                                        var finalInventory = [];
                                        finalInventory.push({
                                            inventory: this.products,
                                            total: this.totalInventory
                                        })
                                        this.$store.dispatch('setInventory', finalInventory).then(()=>{
                                            this.$store.dispatch('setCreditSales', this.creditSales).then(()=>{
                                                var payload = {
                                                    stage: 'Ingreso de datos de negocio',
                                                    description: 'Se ingresan los costos, con gastos operativos e inventario',
                                                    dateTime: moment().format()
                                                };
                                                this.$store.dispatch('setChangeLog', payload).then(()=>{
                                                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].salesPopulate == false || salesChange == true) {
                                                        this.$router.push('/asessments/new_asessment/customer/sales');
                                                        if(salesChange) {
                                                            this.showNotificationError('Es necesario revisar las ventas, por esa razón ha sido redireccionado a esta sección');
                                                        }
                                                    }
                                                    else {
                                                        this.$router.push('/asessments/new_asessment/customer/others/business_references');
                                                    }
                                                });
                                            });
                                        });
                                    }
                                    else {
                                        this.$store.dispatch('setCreditSales', this.creditSales).then(()=>{
                                            var payload = {
                                                stage: 'Ingreso de datos de negocio',
                                                description: 'Se ingresan los costos, con gastos operativos y sin inventario',
                                                dateTime: moment().format()
                                            };
                                            this.$store.dispatch('setChangeLog', payload).then(()=>{
                                                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].salesPopulate == false || salesChange == true) {
                                                    this.$router.push('/asessments/new_asessment/customer/sales');
                                                    if(salesChange) {
                                                        this.showNotificationError('Es necesario revisar las ventas, por esa razón ha sido redireccionado a esta sección');
                                                    }
                                                }
                                                else {
                                                    this.$router.push('/asessments/new_asessment/customer/others/business_references');
                                                }
                                            });
                                        });
                                    }
                                });
                            }
                            else {
                                if (this.operatingSwitches.inventory) {
                                    var finalInventory = [];
                                    finalInventory.push({
                                        inventory: this.products,
                                        total: this.totalInventory
                                    })
                                    this.$store.dispatch('setInventory', finalInventory).then(()=>{
                                        this.$store.dispatch('setCreditSales', this.creditSales).then(()=>{
                                            var payload = {
                                                stage: 'Ingreso de datos de negocio',
                                                description: 'Se ingresan los costos, sin gastos operativos y con inventario',
                                                dateTime: moment().format()
                                            };
                                            this.$store.dispatch('setChangeLog', payload).then(()=>{
                                                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].salesPopulate == false || salesChange == true) {
                                                    this.$router.push('/asessments/new_asessment/customer/sales');
                                                    if(salesChange) {
                                                        this.showNotificationError('Es necesario revisar las ventas, por esa razón ha sido redireccionado a esta sección');
                                                    }
                                                }
                                                else {
                                                    this.$router.push('/asessments/new_asessment/customer/others/business_references');
                                                }
                                            });
                                        });
                                    });
                                }
                                else {
                                    this.$store.dispatch('setCreditSales', this.creditSales).then(()=>{
                                        var payload = {
                                            stage: 'Ingreso de datos de negocio',
                                            description: 'Se ingresan los costos, sin gastos operativos y sin inventario',
                                            dateTime: moment().format()
                                        };
                                        this.$store.dispatch('setChangeLog', payload).then(()=>{
                                            if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].salesPopulate == false || salesChange == true) {
                                                this.$router.push('/asessments/new_asessment/customer/sales');
                                                if(salesChange) {
                                                    this.showNotificationError('Es necesario revisar las ventas, por esa razón ha sido redireccionado a esta sección');
                                                }
                                            }
                                            else {
                                                this.$router.push('/asessments/new_asessment/customer/others/business_references');
                                            }
                                        });
                                    });
                                }
                            }
                        }
                    }
                })
            }
        },
        mounted () {
            if (this.$store.state.isCustomer) {
                this.subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].periodicityOperatingExpenses != null && this.subcategory == 'transporte') {
                    this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].periodicityOperatingExpenses;
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].operatingExpenses.length != 0) {
                    this.operatingSwitches.expenses = true;
                    this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].periodicityOperatingExpenses;
                    this.actualExpenses = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].operatingExpenses;
                    this.periodicity_days = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].daysOperatingExpenses;
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].daysOperatingExpenses != 0) {
                        this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].periodicityOperatingExpenses;
                        this.periodicity_days = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].daysOperatingExpenses;
                    }
                    this.expenses = Expenses;
                    for (let i=0; i<this.expenses.length;i++) {
                        this.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].creditSales.value != 0) {
                    this.operatingSwitches.creditSales = true;
                    this.creditSales.value = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].creditSales.value;
                    this.creditSales.description = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].creditSales.description;
                }
                if(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalInventory != 0) {
                    this.operatingSwitches.inventory = true;
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].inventory;
                }
                this.subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                if(this.subcategory == 'transporte') {
                    let index = this.actualExpenses.findIndex((tableRow) => tableRow.name === 'Transporte');
                    let indexTaxes = this.actualExpenses.findIndex((tableRow) => tableRow.name === 'Impuestos');
                    var transportCosts = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].transportCosts;
                    var sum = 0
                    var sum_others = 0
                    for (let i=0;i<transportCosts[0].expenses.length;i++) {
                        if(transportCosts[0].expenses[i].name == 'Combustible') {
                            sum = sum + parseFloat(transportCosts[0].expenses[i].value);
                        }
                        else {
                            sum_others = sum_others + parseFloat(transportCosts[0].expenses[i].value);
                        }
                    }
                    var sum_taxes = 0;
                    var taxes = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].transportCosts[0].taxes;
                    for (let j=0; j<taxes.length;j++) {
                        sum_taxes = sum_taxes + parseFloat(taxes[j].value);
                    }
                    // this.actualExpenses[indexTaxes].value = sum_taxes;
                    this.actualExpenses[indexTaxes].value = 0;
                    let indexActual = 0;
                    indexActual = this.actualExpenses.findIndex((tableRow) => tableRow.name === 'Otros gastos');
                    if(sum != 0) {
                        this.actualExpenses[index].value = sum;
                    }
                    if(indexActual == 0 && sum_others != 0) {
                        var id = this.actualExpenses.length + 1;
                        this.actualExpenses.push({
                            id: id,
                            name: 'Otros gastos',
                            value: sum_others,
                            locked: false
                        })
                    }
                    else if(indexActual != 0 && sum_others != 0){
                        this.actualExpenses.splice(indexActual,1);
                        var id = this.actualExpenses.length + 1;
                        this.actualExpenses.push({
                            id: id,
                            name: 'Otros gastos',
                            value: sum_others,
                            locked: false
                        })
                    }
                    if (sum_others != 0 || sum_taxes != 0 || sum != 0) {
                        this.operatingSwitches.expenses = true;
                    }
                }
            }
            else if(this.$store.state.isSpouse) {
                this.subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].periodicityOperatingExpenses != null && this.subcategory == 'transporte') {
                    this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].periodicityOperatingExpenses;
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].operatingExpenses.length != 0) {
                    this.operatingSwitches.expenses = true;
                    this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].periodicityOperatingExpenses;
                    this.actualExpenses = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].operatingExpenses;
                    this.periodicity_days = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].daysOperatingExpenses;
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].daysOperatingExpenses != 0) {
                        this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].periodicityOperatingExpenses;
                        this.periodicity_days = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].daysOperatingExpenses;
                    }
                    this.expenses = Expenses;
                    for (let i=0; i<this.expenses.length;i++) {
                        this.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].creditSales.value != 0) {
                    this.operatingSwitches.creditSales = true;
                    this.creditSales.value = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].creditSales.value;
                    this.creditSales.description = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].creditSales.description;
                }
                if(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalInventory != 0) {
                    this.operatingSwitches.inventory = true;
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].inventory;
                }
                this.subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                if(this.subcategory == 'transporte') {
                    let index = this.actualExpenses.findIndex((tableRow) => tableRow.name === 'Transporte');
                    let indexTaxes = this.actualExpenses.findIndex((tableRow) => tableRow.name === 'Impuestos');
                    var transportCosts = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].transportCosts;
                    var sum = 0
                    var sum_others = 0
                    for (let i=0;i<transportCosts[0].expenses.length;i++) {
                        if(transportCosts[0].expenses[i].name == 'Combustible') {
                            sum = sum + parseFloat(transportCosts[0].expenses[i].value);
                        }
                        else {
                            sum_others = sum_others + parseFloat(transportCosts[0].expenses[i].value);
                        }
                    }
                    var sum_taxes = 0;
                    var taxes = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].transportCosts[0].taxes;
                    for (let j=0; j<taxes.length;j++) {
                        sum_taxes = sum_taxes + parseFloat(taxes[j].value);
                    }
                    // this.actualExpenses[indexTaxes].value = sum_taxes;
                    this.actualExpenses[indexTaxes].value = 0;
                    let indexActual = 0;
                    indexActual = this.actualExpenses.findIndex((tableRow) => tableRow.name === 'Otros gastos');
                    if(sum != 0) {
                        this.actualExpenses[index].value = sum;
                    }
                    if(indexActual == 0 && sum_others != 0) {
                        var id = this.actualExpenses.length + 1;
                        this.actualExpenses.push({
                            id: id,
                            name: 'Otros gastos',
                            value: sum_others,
                            locked: false
                        })
                    }
                    else if(indexActual != 0 && sum_others != 0){
                        this.actualExpenses.splice(indexActual,1);
                        var id = this.actualExpenses.length + 1;
                        this.actualExpenses.push({
                            id: id,
                            name: 'Otros gastos',
                            value: sum_others,
                            locked: false
                        })
                    }
                    if (sum_others != 0 || sum_taxes != 0 || sum != 0) {
                        this.operatingSwitches.expenses = true;
                    }
                }
            }
            if (this.$store.state.isGuarantor) {
                this.subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].periodicityOperatingExpenses != null && this.subcategory == 'transporte') {
                    this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].periodicityOperatingExpenses;
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].operatingExpenses.length != 0) {
                    this.operatingSwitches.expenses = true;
                    this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].periodicityOperatingExpenses;
                    this.actualExpenses = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].operatingExpenses;
                    this.periodicity_days = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].daysOperatingExpenses;
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].daysOperatingExpenses != 0) {
                        this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].periodicityOperatingExpenses;
                        this.periodicity_days = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].daysOperatingExpenses;
                    }
                    this.expenses = Expenses;
                    for (let i=0; i<this.expenses.length;i++) {
                        this.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].creditSales.value != 0) {
                    this.operatingSwitches.creditSales = true;
                    this.creditSales.value = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].creditSales.value;
                    this.creditSales.description = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].creditSales.description;
                }
                if(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalInventory != 0) {
                    this.operatingSwitches.inventory = true;
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].inventory;
                }
                this.subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                if(this.subcategory == 'transporte') {
                    let index = this.actualExpenses.findIndex((tableRow) => tableRow.name === 'Transporte');
                    let indexTaxes = this.actualExpenses.findIndex((tableRow) => tableRow.name === 'Impuestos');
                    var transportCosts = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].transportCosts;
                    var sum = 0
                    var sum_others = 0
                    for (let i=0;i<transportCosts[0].expenses.length;i++) {
                        if(transportCosts[0].expenses[i].name == 'Combustible') {
                            sum = sum + parseFloat(transportCosts[0].expenses[i].value);
                        }
                        else {
                            sum_others = sum_others + parseFloat(transportCosts[0].expenses[i].value);
                        }
                    }
                    var sum_taxes = 0;
                    var taxes = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].transportCosts[0].taxes;
                    for (let j=0; j<taxes.length;j++) {
                        sum_taxes = sum_taxes + parseFloat(taxes[j].value);
                    }
                    // this.actualExpenses[indexTaxes].value = sum_taxes;
                    this.actualExpenses[indexTaxes].value = 0;
                    let indexActual = 0;
                    indexActual = this.actualExpenses.findIndex((tableRow) => tableRow.name === 'Otros gastos');
                    if(sum != 0) {
                        this.actualExpenses[index].value = sum;
                    }
                    if(indexActual == 0 && sum_others != 0) {
                        var id = this.actualExpenses.length + 1;
                        this.actualExpenses.push({
                            id: id,
                            name: 'Otros gastos',
                            value: sum_others,
                            locked: false
                        })
                    }
                    else if(indexActual != 0 && sum_others != 0){
                        this.actualExpenses.splice(indexActual,1);
                        var id = this.actualExpenses.length + 1;
                        this.actualExpenses.push({
                            id: id,
                            name: 'Otros gastos',
                            value: sum_others,
                            locked: false
                        })
                    }
                    if (sum_others != 0 || sum_taxes != 0 || sum != 0) {
                        this.operatingSwitches.expenses = true;
                    }
                }
            }

        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
